<template>
  <div class="wrap">
    <div class="container lnb">
      <div class="contents_wrap">
        <div class="contents">
          <div class="title">
            {{ title }}
            <div class="clear"></div>
          </div>
          <div class="table_wrap">
            <el-table
              :data="tableFilter.slice(pagnation.size * (page - 1 ), pagnation.size * page)"
              style="width: 100%"
              empty-text="데이터가 없습니다."
            >
              <el-table-column
                class="table_no"
                type="index"
                label="번호"
                width="100"
                class-name="num"
                :index="tableIndex"
              >
              </el-table-column>
              <el-table-column v-for="header in tableHeader" :key="header.prop"
                               :label = header.label
                               :prop = header.prop
                               :width = header.width
                               sortable
                               :class-name = header.prop
              ></el-table-column>
            </el-table>
          </div>
          <div class="pagnation_wrap" v-show="filterPagnation.total">
            <el-pagination
              :page-size = filterPagnation.size
              :pager-count = filterPagnation.pagerCount
              layout="prev, pager, next"
              :current-page.sync = page
              :total="filterPagnation.total"
            >
            </el-pagination>
          </div>
        </div>
        <page-footer></page-footer>
      </div>
    </div>
  </div>
</template>

<script>
  import VuxAlert from '@/mixins/vux-alert';

  export default {
    name: "LocationLog",
    components: {},
    mixins: [ VuxAlert ],
    data(){
      return{
        data : {},
        title: this.$route.meta.title,
        tableData: [],
        orgTableData : [],
        categoryData : [],
        tableSearch: '',
        tableHeader: [
          {
            label : '대상',
            prop : 'wr_subject'
          },
          {
            label : '취득경로',
            prop : 'path'
          },
          {
            label : '제공서비스',
            prop : 'service'
          },
          {
            label : '제공받는자',
            prop : 'name'
          },
          {
            label: '이용일시',
            prop: 'updated_at',
            width: '200'
          }
        ],
        tableoption: true,
        pagnation: {
          size: 10,
          pagerCount: 11,
          page: 1,
        },
        page : 1,
        tableSelected: '',
        categorySelected : '',
      }
    },
    computed: {
      tableFilter() {
        return this.tableData.filter(data => !this.tableSearch || data[this.tableSelected].includes(this.tableSearch))
      },
      filterPagnation() {
        this.resetPage()
        return {
          size: 10,
          pagerCount: 11,
          total: this.tableFilter.length,
          page: 1
        }
      }
    },
    mounted() {
      this.getList();
    },

    methods: {
      resetPage() {
        this.page = 1
      },
      async getList() {
        await this.$api.$board.getSafety().then( res => res.Data.Result).then(res => {
          res.List =  [{wr_id: 28, mb_no: 4, wr_parent: 0, wr_subject: "경기도 성남시 야탑동",path:"사용자 신고 및 실행",service:"GPS상 위경도를 주소로 변경 제공",name:"potential886@naver.com",updated_at : "2019-03-19 12:12:12"},
           {wr_id: 28, mb_no: 4, wr_parent: 0, wr_subject: "경기도 성남시 야탑동",path:"사용자 신고 및 실행",service:"GPS상 위경도를 주소로 변경 제공",name:"potential886@naver.com",updated_at : "2019-03-19 12:12:12"},
           {wr_id: 27, mb_no: 4, wr_parent: 0, wr_subject: "경기도 성남시 야탑동",path:"사용자 신고 및 실행",service:"GPS상 위경도를 주소로 변경 제공",name:"potential886@naver.com",updated_at : "2019-03-19 12:12:12"},
           {wr_id: 26, mb_no: 4, wr_parent: 0, wr_subject: "경기도 성남시 야탑동 ",path:"사용자 신고 및 실행",service:"GPS상 위경도를 주소로 변경 제공",name:"potential886@naver.com",updated_at : "2019-03-19 12:12:12"},
           {wr_id: 25, mb_no: 4, wr_parent: 0, wr_subject: "화재 경기도 성남시 야탑동",path:"사용자 신고 및 실행",service:"GPS상 위경도를 주소로 변경 제공",name:"potential886@naver.com",updated_at : "2019-03-19 12:12:12"},
           {wr_id: 24, mb_no: 4, wr_parent: 0, wr_subject: "인천시 남동구 간석동 ",path:"사용자 신고 및 실행",service:"GPS상 위경도를 주소로 변경 제공",name:"potential886@naver.com",updated_at : "2019-03-19 12:12:12"},
           {wr_id: 23, mb_no: 4, wr_parent: 0, wr_subject: "경기도 성남시 야탑동",path:"사용자 신고 및 실행",service:"GPS상 위경도를 주소로 변경 제공",name:"potential886@naver.com",updated_at : "2019-03-19 12:12:12"},
           {wr_id: 10, mb_no: 1, wr_parent: 0, wr_subject: "인천시 남동구 간석동",path:"사용자 신고 및 실행",service:"GPS상 위경도를 주소로 변경 제공",name:"potential886@naver.com",updated_at : "2019-03-19 12:12:12"}]

          this.tableData = res.List;
        })
      },
      tableIndex(index) {
        return index + this.pagnation.size * (this.page - 1) +1
      },
    }
  }
</script>
<style>

</style>
